<template>
  <div class="w-full">
    <portal :to="PortalTarget.BRAND_SEARCH_BAR">
      <div class="status-select-wrapper">
        <select-input
          :value="selectedStatus"
          :options="statusOptions"
          hide-autocomplete
          option-value-name="value"
          option-label-name="label"
          class="w-full"
          @input="(value) => (selectedStatus = value)"
        />
      </div>
    </portal>
    <slot-tabs
      :tabs="tabs"
      :active-tab="activeTab"
      header-container-class="w-full bg-white px-2.5 md:px-12 py-2"
      @select-tab="selectTab"
    >
      <template #[USER_TABS.ALL]>
        <users-list
          :additional-query="statusQueryParam"
          :with-top-padding="true"
        />
      </template>

      <template #[USER_TABS.NOT_ASSIGNED]>
        <users-list
          :additional-query="{ role: 'none', ...statusQueryParam }"
          :with-top-padding="true"
        />
      </template>
    </slot-tabs>
  </div>
</template>

<script>
import UsersList from '@/views/Brand/Users/Components/UsersList.vue';
import SlotTabs from '@/components/Tabs/SlotTabs.vue';
import { ref, computed } from '@vue/composition-api';
import { PortalTarget } from '@/constants/portal';
import { SelectInput } from '@/components/Inputs/SelectInput';
import { USER_STATUS_MAP } from '@/constants/user';

const USER_TABS = {
  ALL: 'all',
  NOT_ASSIGNED: 'not-assigned',
};

export default {
  name: 'Users',
  components: {
    UsersList,
    SlotTabs,
    SelectInput,
  },
  setup(props, ctx) {
    const activeTab = ref(USER_TABS.NOT_ASSIGNED);

    const tabs = computed(() => ({
      [USER_TABS.ALL]: {
        name: USER_TABS.ALL,
        label: ctx.root.$t('brand-users-list-view.all'),
      },
      [USER_TABS.NOT_ASSIGNED]: {
        name: USER_TABS.NOT_ASSIGNED,
        label: ctx.root.$t('brand-users-list-view.not-assigned'),
      },
    }));

    const selectTab = (tab) => {
      activeTab.value = tab.name;
    };

    const statusOptions = computed(() =>
      Object.entries(USER_STATUS_MAP).map(([key, value]) => ({
        label: ctx.root.$t(`user-status.${key.toLocaleLowerCase()}`),
        value,
      })),
    );

    const selectedStatus = ref(statusOptions.value[0]);

    const statusQueryParam = computed(() =>
      selectedStatus.value.value === USER_STATUS_MAP.ALL
        ? {}
        : { status: selectedStatus.value.value },
    );

    return {
      activeTab,
      tabs,
      selectTab,
      USER_TABS,
      PortalTarget,
      USER_STATUS_MAP,
      statusOptions,
      selectedStatus,
      statusQueryParam,
    };
  },
};
</script>
<style scoped lang="scss">
.status-select-wrapper {
  @apply pt-2;
  width: 180px;
}
</style>
